
import { Vue, Component } from "vue-property-decorator";

@Component({
    name: "FooterBar",
})
export default class FooterBar extends Vue {

}
